import {sessionUsername} from "../../config";

export function stripPTag(text) {
  return text
    .replace("</p><p>", "<br />")
    .replace(/(<p[^>]+?>|<p>|<\/p>)/gim, "");
}

export function stripTags(text) {
  return text.replace(/<(.|\n)*?>/g, "");
}

export function checkImgSize(text) {
  let imgString = stripPTag(text);
  let regex = /<img.*?src="(.*?)"/;
  if (imgString.match(regex)) {
    var src = regex.exec(imgString)[1];
    var base64String = src.split(",")[1];

    let padding, inBytes, base64StringLength;
    if (base64String.endsWith("==")) padding = 2;
    else if (base64String.endsWith("=")) padding = 1;
    else padding = 0;

    base64StringLength = base64String.length;
    inBytes = (base64StringLength / 4) * 3 - padding;

    // var sizeKB = size/1000;
    let sizeMB = inBytes / 1000000;

    if (sizeMB > 1) return false;
  }
  return true;
}

export function getIdentity() {
  let identity = "";
  const username = sessionStorage.getItem(sessionUsername);
  if (username) {
    identity = username;
  }
  return identity;
}

export function extractMultiSelectIDs(objects) {
  return objects.map((o) => o.value);
}

export function isNullOrEmpty(str) {
  return (
    str === null ||
    str === undefined ||
    (typeof str === "string" && str.trim().length === 0)
  );
}
